import { classNames } from 'primereact/utils';
import {
  DropdownContext,
  DropdownPassThroughOptions,
  DropdownProps,
  DropdownState,
} from 'primereact/dropdown';

export const PTDropdown: DropdownPassThroughOptions = {
  root: ({ props, state }: { props: DropdownProps; state: DropdownState }) => ({
    className: classNames(
      'ax-dropdown',
      'transition-colors duration-50 ease-in-out',
      {
        'ax-dropdown--disabled': props.disabled,
        'ax-dropdown--focused': state.focused,
      },
    ),
  }),
  input: ({ props }: any) => ({
    className: classNames('ax-dropdown__input', 'transition duration-50', {
      'pr-4': props.showClear,
    }),
  }),
  panel: {
    className: 'min-w-96 ax-shadow',
  },
  trigger: {
    className: classNames('ax-dropdown__trigger'),
  },
  wrapper: ({ props }: { props: DropdownProps }) => ({
    className: classNames('ax-dropdown__wrapper ax-scrollbar max-h-96!', {
      '!rounded-t-none': props.filter,
    }),
  }),
  list: {
    className: classNames('ax-dropdown__wrapper__list'),
  },
  item: ({
    props,
    context,
  }: {
    props: DropdownProps;
    context: DropdownContext;
  }) => ({
    className: classNames(
      'ax-dropdown__wrapper__list__item',
      'transition-shadow duration-50',
      {
        'ax-dropdown__wrapper__list__item__text':
          !context.focused && !context.selected,
        'ax-dropdown__wrapper__list__item__bg':
          context.focused && !context.selected,
        'ax-dropdown__wrapper__list__item--focused':
          context.focused && context.selected,
        'ax-dropdown__wrapper__list__item--selected':
          !context.focused && context.selected,
        'ax-dropdown__wrapper__list__item--disabled': context.disabled,
      },
      {
        'px-2 py-1': !props.itemTemplate,
      },
    ),
  }),
  itemGroup: {
    className: classNames(
      'm-0 p-3 text-gray-800 bg-white font-bold',
      'dark:bg-gray-900 dark:text-white/80',
      'cursor-auto',
    ),
  },
  header: {
    className: classNames('p-3 rounded-tl-lg rounded-tr-lg bg-white'),
  },
  filterContainer: {
    className: 'relative',
  },
  filterInput: {
    className: classNames('ax-input ax-input--sm', 'pr-7 -mr-7', 'w-full'),
    'data-testid': 'filter-input',
  },
  filterIcon: {
    className: '-mt-2 mr-2 absolute top-1/2 right-0 w-3',
  },
  clearIcon: {
    className: 'absolute text-gray-500 right-8',
  },
  transition: {
    classNames: {
      enter: 'opacity-0 scale-75',
      enterDone: 'transition-transform transition-opacity duration-50 ease-in',
      exit: 'transition-opacity duration-50 ease-linear',
      exitDone: 'opacity-0',
    },
    timeout: { enter: 50, exit: 50 },
  },
  virtualScroller: {
    root: {
      className: 'ax-scrollbar min-w-52',
    },
  },
};
